"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrimmerControls = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FineTuneTrimButton = require("./FineTuneTrimButton");

var _atoms = require("../../atoms");

var _DurationDisplay = require("./DurationDisplay");

var _TrimmerCanvas = require("./TrimmerCanvas");

var _Trimmer = require("./Trimmer");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Trimmer Controls
var TrimmerControls = function TrimmerControls(_ref) {
  var type = _ref.type,
      stopAt = _ref.stopAt,
      startAt = _ref.startAt,
      initialStartAt = _ref.initialStartAt,
      duration = _ref.duration,
      fullGameMoment = _ref.fullGameMoment,
      videoUrl = _ref.videoUrl,
      onChangeStartStop = _ref.onChangeStartStop,
      fullGameMomentDuration = _ref.fullGameMomentDuration,
      videoPlayerContainerRef = _ref.videoPlayerContainerRef,
      onChangeIsValidTrim = _ref.onChangeIsValidTrim;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      forceReload = _useState2[0],
      setForceReload = _useState2[1];

  var _useState3 = (0, _react.useState)(duration < 150),
      _useState4 = _slicedToArray(_useState3, 2),
      validTrim = _useState4[0],
      setValidTrim = _useState4[1];

  var handleOnChangeStart = function handleOnChangeStart(newStart) {
    if (isNaN(newStart)) return;
    if (newStart === startAt) return;

    if (typeof onChangeStartStop === "function") {
      onChangeStartStop(newStart, stopAt);
    }
  };

  var handleOnChangeStop = function handleOnChangeStop(newStop) {
    if (isNaN(newStop)) return;
    if (newStop === stopAt) return;

    if (typeof onChangeStartStop === "function") {
      onChangeStartStop(startAt, newStop);
    }
  };

  var handleForceOnChangeStart = function handleForceOnChangeStart(newStart) {
    if (isNaN(newStart)) return;
    if (newStart === startAt) return;

    if (typeof onChangeStartStop === "function") {
      onChangeStartStop(newStart, stopAt);
      setForceReload(function (old) {
        return old + 1;
      });
    }
  };

  var handleForceOnChangeStop = function handleForceOnChangeStop(newStop) {
    if (isNaN(newStop)) return;
    if (newStop === stopAt) return;

    if (typeof onChangeStartStop === "function") {
      onChangeStartStop(startAt, newStop);
      setForceReload(function (old) {
        return old + 1;
      });
    }
  }; // Valid trim


  (0, _react.useEffect)(function () {
    setValidTrim(duration < 150 && duration >= 2);
  }, [duration]);
  (0, _react.useEffect)(function () {
    if (typeof onChangeIsValidTrim === "function") {
      onChangeIsValidTrim(validTrim);
    }
  }, [validTrim]);
  return /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "TrimmerControls"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "personalize-controls-spotlight",
    marginTop: "8"
  }, /*#__PURE__*/_react.default.createElement(_Trimmer.Trimmer, {
    type: type,
    startAt: startAt,
    initialStartAt: initialStartAt,
    stopAt: stopAt,
    videoUrl: videoUrl,
    onChangeStop: function onChangeStop(newStop) {
      return handleOnChangeStop(newStop);
    },
    onChangeStart: function onChangeStart(newStart) {
      return handleOnChangeStart(newStart);
    },
    videoPlayerContainerRef: videoPlayerContainerRef,
    fullVideoDuration: fullGameMomentDuration,
    duration: duration,
    key: forceReload,
    validTrim: validTrim
  }), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "buttons-container",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "4"
  }, /*#__PURE__*/_react.default.createElement(_FineTuneTrimButton.FineTuneTrimButton, {
    title: "Start",
    adjusting: "start",
    startAt: startAt,
    stopAt: stopAt,
    maxDuration: Math.min(fullGameMomentDuration, 150),
    onChangeStart: function onChangeStart(newStart) {
      return handleForceOnChangeStart(newStart);
    },
    onChangeStop: function onChangeStop(newStop) {
      return handleForceOnChangeStop(newStop);
    },
    validTrim: validTrim
  }), /*#__PURE__*/_react.default.createElement(_DurationDisplay.DurationDisplay, {
    duration: "".concat(parseFloat(duration).toFixed(1), "s"),
    marginLeft: "4",
    marginRight: "4"
  }), /*#__PURE__*/_react.default.createElement(_FineTuneTrimButton.FineTuneTrimButton, {
    title: "End",
    adjusting: "stop",
    startAt: startAt,
    stopAt: stopAt,
    maxDuration: Math.min(fullGameMomentDuration, 150),
    onChangeStart: function onChangeStart(newStart) {
      return handleForceOnChangeStart(newStart);
    },
    onChangeStop: function onChangeStop(newStop) {
      return handleForceOnChangeStop(newStop);
    },
    validTrim: validTrim
  })), !validTrim && /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    alignItems: "center",
    color: _atoms.Color.Grey2,
    justifyContent: "center",
    width: "100%"
  }, parseFloat(duration) > parseFloat(150) && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.SmallBody,
    marginTop: "4"
  }, "Reduce clip length (max: 150s)"), parseFloat(duration) < parseFloat(2) && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.SmallBody,
    marginTop: "4"
  }, "Increase clip length (min: 2s)"))));
};

exports.TrimmerControls = TrimmerControls;
TrimmerControls.defaultProps = {
  stopAt: 0.0,
  startAt: 0.0
};